export default class Images {
    constructor(images) {
        this.images = images;
    }
}